import React from "react";
import { PhoneIcon } from "lucide-react";
import { firm, footerGroups, resultsDisclaimer } from "../data/site";
import { SiteLink } from "./SiteLink";
export function SiteFooter() {
  return <footer className="on-dark bg-ink text-white" data-id="element-334" data-mp="3mh1206y44y0m">
      <div className="page-container py-14 md:py-16" data-id="element-335" data-mp="3mfpxg4wufm8g">
        <div className="grid gap-10 md:grid-cols-12" data-id="element-336" data-mp="3hj7xrjgdee2z">
          <div className="md:col-span-6" data-id="element-337" data-mp="3hglsjqgycanx">
            <p className="text-h3 font-bold" data-id="element-338" data-mp="3dh4kcpa54zf2">{firm.displayName}</p>
            <p className="mt-1 text-white/80" data-id="element-339" data-mp="38hrmzaln89y8">
              Michigan motorcycle injury representation.
            </p>
            <a href={firm.phoneHref} className="mt-5 inline-flex min-h-[48px] items-center gap-3 text-h3 font-extrabold text-white hover:underline" data-id="element-340" data-mp="33i59d01wkrow">
              <PhoneIcon aria-hidden="true" className="h-6 w-6" data-id="element-341" data-mp="11r1xk7ga172r" />
              {firm.phoneDisplay}
            </a>
            <div className="mt-3" data-id="element-342" data-mp="wrz47k9nspam">
              <SiteLink path="/contact-us/" className="inline-flex min-h-[44px] items-center text-label font-semibold text-white underline underline-offset-4" data-id="element-343" data-mp="wsqs08x0liqc">
                Contact the firm
              </SiteLink>
            </div>
          </div>
          {footerGroups.map(group => <nav key={group.id} aria-labelledby={group.id} className="md:col-span-3" data-id="element-344" data-mp="vu8o4dctrwe8">
              <h2 id={group.id} className="text-label font-bold text-white/80" data-id="element-345" data-mp="10sjyqqay2axi">
                {group.label}
              </h2>
              <ul className="mt-3" data-id="element-346" data-mp="1ojfyqapk0cfu">
                {group.links.map(link => <li key={link.path} data-id="element-347" data-mp="1tfwn960o0stg">
                    <SiteLink path={link.path} className="inline-flex min-h-[44px] items-center text-label font-semibold text-white underline-offset-4 hover:underline" data-id="element-348" data-mp="1erjmlvqmulsm">
                      {link.label}
                    </SiteLink>
                  </li>)}
              </ul>
            </nav>)}
        </div>
        <div className="mt-12 flex flex-col gap-3 border-t border-white/20 pt-6 text-meta text-white/80 md:flex-row md:justify-between" data-id="element-349" data-mp="2m2xmtvi132a8">
          <p data-id="element-350" data-mp="2h4w81mrmxp4k">{resultsDisclaimer}</p>
          <div data-id="element-351" data-mp="2h1qh01zg4d67">
            <SiteLink path="/privacy-policy/" className="inline-flex min-h-[44px] items-center font-semibold text-white underline underline-offset-4" data-id="element-352" data-mp="2d27wh7bje43w">Privacy Policy</SiteLink>
            <p data-id="element-353" data-mp="282vd4wjvjf62">© 2026 {firm.legalName}</p>
          </div>
        </div>
      </div>
    </footer>;
}